export const PUBLIC_ROUTE_NAMES = new Set([
  'Login',
  'JoinStep01',
  'JoinStep02',
  'JoinStep03',
  'ErrorPage404',
  'ErrorPage401',
  'ResearchIntro',
  'main'
])

export function isPublicRoute(route) {
  return PUBLIC_ROUTE_NAMES.has(route?.name)
}
